<template>
  <main class="app-main">
    <!--begin::App Content Header-->
    <div class="app-content-header">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row">
          <div class="col-sm-6"><h3 class="mb-0">{{ rowTitle }}</h3></div>
          <div class="col-sm-6">
            <ol class="breadcrumb float-sm-end">
              <li class="breadcrumb-item"><router-link to="/">الرئيسية</router-link></li>
              <li class="breadcrumb-item"><router-link to="/pTransactions">المعاملات المالية للمزود</router-link></li>
              <li class="breadcrumb-item active" aria-current="page">{{ rowTitle }}</li>
            </ol>
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content Header-->
    <!--begin::App Content-->
    <div class="app-content">
      <!--begin::Container-->
      <div class="container-fluid">
        <!--begin::Row-->
        <div class="row justify-content-center">
          <div class="col-12 col-sm-10">
            <errorAlert v-if="hasError" :alertMessage="message" :errorNumber="errorNumber" />
            <mainLoader v-if="mainLoading" />
            <PTransactionsForm v-if="!mainLoading && checkAccess('providers_transactions_update')" 
              :cardTitle="rowTitle" 
              :dataRow="row" 
              :transactionsTypes="transactionsTypes"
              :statusObject="statusChioces"
            />
            <PTransactionsView v-if="!mainLoading && !checkAccess('providers_transactions_update')" 
              :cardTitle="rowTitle" 
              :dataRow="row" 
              :transactionsTypes="transactionsTypes"
              :statusObject="statusChioces"
            />
            <AdminNotesPanel
              v-show="!mainLoading"
              modelName="ProviderTransactions"
              :recordId="id"
            />
          </div>
        </div>
        <!--end::Row-->
      </div>
      <!--end::Container-->
    </div>
    <!--end::App Content-->
  </main>
</template>

<script>
import { checkAccess } from '@/helpers/tools';
import PTransactionsForm from './form.vue';
import PTransactionsView from './view.vue';
import AdminNotesPanel from '../admin_notes/adminNotesPanel.vue';

export default {
  name: 'PTransactionsUpdate',
  components: {
    PTransactionsForm, PTransactionsView, AdminNotesPanel
  },
  data(){
    return {
      id: this.$route.params.id,
      mainLoading: true,
      hasError: false,
      message: '',
      errorNumber: 0,
      rowTitle: 'تعديل معاملة ',
      row: null,
      statusChioces: {},
      transactionsTypes: {},
    }
  },
  methods: {
    checkAccess,
    getRowData(){
      this.$http.get(`/api/admin/pTransactions/retrieve/${this.id}`).then(({data}) => {
        if(data.row.Provider)
          this.rowTitle = this.rowTitle + data.row.Provider.name;
        this.row = data.row;
        this.transactionsTypes = data.transactionsTypes;
        this.statusChioces = data.transactionsStatus;
        this.mainLoading = false;
      }).catch(err => {
        [this.message, this.errorNumber] = this.$globalError(err, true);
        this.hasError = true;
        window.scrollTo({ top: 0, behavior: 'smooth' });
      });
    },
  },
  created(){
    this.getRowData();
  }
}
</script>
